import { useState, useCallback } from 'react';
import axios from 'axios';
import notify, { MESSAGES } from '../../../utils/notify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';

const useChangeEvaluationStatus = () => {
  const [isLoading, setIsLoading] = useState(false);

  const changeStatus = useCallback(
    async ({ procurementId, newStatus = 3, onSuccess }) => {
      if (!procurementId) return false;

      const token = getAuthToken();
      if (!token) {
        notify.error(MESSAGES.authRequired);
        return false;
      }

      setIsLoading(true);
      try {
        await axios.post(
          `${api.API_URL}/procurement/change-evaluation-status`,
          { procurementId, newStatus },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        notify.success('Tender evaluation status updated successfully.');
        onSuccess?.();
        return true;
      } catch (err) {
        notify.apiError(err, 'update tender evaluation status');
        return false;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return { changeStatus, isLoading };
};

export default useChangeEvaluationStatus;
